//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, timeAgo} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import moment from 'moment';
import DJAreaSideMenu from './sidemenu';
import CopyBox from '../components/bbcode/copy-box';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import '../css/djaccounts.css';

export default class AdminDJAccounts extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			accounts: {},
			live: '',
			next: '',
			recover: false,
			recover_url: '',
			validate: false,
		};
		this.refreshOBS = this.refreshOBS.bind(this);
		this.resetPassword = this.resetPassword.bind(this);
		this.closeRecover = this.closeRecover.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Admin - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		let params = new URLSearchParams();
		const x = await postApi('/api/v2/admin/djaccounts', params);
		this.setState({accounts: x.data.Accounts, live: x.data.Live, next: x.data.Next});
	}

	componentWillUnmount() {
	}

	async refreshOBS(id) {
		let params = new URLSearchParams();
		params.append('id', id);
		await putApi('/api/v2/admin/djaccountsObs', params);
	}

	async resetPassword(id) {
		let params = new URLSearchParams();
		params.append('uid', id);
		let x = await putApi('/api/v2/admin/djaccountsRecover', params);
		//console.log(x.data);
		this.setState({recover: true, recover_url: x.data.url});
	}
	closeRecover() {
		this.setState({recover: false, recover_url: ''});
	}
	
	async validateAccounts() {
		if( window.confirm("Are you sure you wish to verify all the accounts, this may take a few moments and please don't change the page") ) {
			this.setState({validate: true},async ()=>{
				let params = new URLSearchParams();
				let x = await postApi('/api/v2/admin/djaccountsValidate', params);
				this.setState({validate: false});
			})
		}
	}

	render() {
		const accounts = 
      Object.keys(this.state.accounts).map((e,i) => {
        return (
          <Col key={i} xs={12} >
						<Row className="py-1 gx-0">
							<div style={{width: 80}}><img src={`https://mix365.co.uk${this.state.accounts[e].avatar}`}  alt="Profile Avatar" className="djaccounts-avatar" /></div>
							<Col className="text-vertical">{this.state.accounts[e].username}<br />{this.state.accounts[e].icecast_password}</Col>
							<Col className="text-vertical">{this.state.accounts[e].email}</Col>
							<Col className="text-vertical">{moment(this.state.accounts[e].lastconnect*1000).format("ddd Do MMM ~ HH:mm:ss")}</Col>
							<Col className="text-vertical">{timeAgo(parseInt(this.state.accounts[e].lastplayed))}</Col>
							<Col className="text-vertical"><Button size="sm" onClick={()=>{this.resetPassword(this.state.accounts[e].id)}}>Send Recovery Email</Button></Col>
						</Row>
          </Col>
        )
      })
		return (
			<>
				<Row className="dj-area pt-4 pb-5 px-4">
					<Col xs={12} md={2} className="djarea-sidemenu">
						<DJAreaSideMenu />
					</Col>
					<Col>
						<Row>
							<Col>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">DJ Accounts</h3>
									</div>
									<div className="card-body">
										<Row className="gx-0">
											<Col xs={12} className="text-right">
												<Button size="sm" onClick={()=>this.validateAccounts()} disabled={this.state.validate}>Validate</Button>
											</Col>
											<div className="" style={{width: 80}}>

											</div>
											<Col>Account</Col>
											<Col>Email</Col>
											<Col>Last Logged In</Col>
											<Col>Last Played</Col>
											<Col>Recover Account</Col>
										</Row>
										<Row className="gx-0">
											{accounts}
										</Row>
									</div>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
				<Modal
					show={this.state.recover}
					onHide={this.closeRecover}
					size="lg"
					aria-labelledby="contained-modal-title-vcenter"
					centered
				>
					<Modal.Header closeButton className="bg-dark">
						<Modal.Title id="contained-modal-title-vcenter">
							Recover Account
						</Modal.Title>
					</Modal.Header>
					<Modal.Body className="bg-dark">
						<p>URL to recover account access</p>
						<CopyBox content={this.state.recover_url} />
					</Modal.Body>
					<Modal.Footer className="bg-dark">
						
					</Modal.Footer>
				</Modal>
			</>
		);
	}
}
